import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MapProjectionService {

  constructor() { }

  getGeoLineColor(aircraft: string): string {
    
    switch (aircraft) {
      case 'A300':
      return 'red';
      case 'A330':
      return 'orange';
      case 'A319':
      case 'A320':
      case 'A321':
      return 'blue';
      case 'B737':
      return 'green';
      case 'B727':
      return 'magenta';
      case 'B757':
      case 'B767':
      return 'purple';
      case 'B777':
      return 'navy';
      case 'B787':
      return 'brown';
      case 'S80':
      return 'cyan';
      default:
      return 'black';
    }
    
  }
}
